export const cidPopover = (popoverPlacement) => {
    var popoverPlacement = (Modernizr.mq('(max-width: 800px)')) ? 'bottom' : 'right';
    $('[rel=cid-popover]').popover({
        html: true,
        animation: true,
        placement: popoverPlacement,
        title: "Where is the Card Identification Data (CID)?",
        content: function() {
            return $($(this).data('contentwrapper')).html();
        }
    });
}

export const cidOrientationChange = () => {
  if ($('.tabletPage').length > 0) {
    window.addEventListener("orientationchange", function() {
      if ($('.popover').length > 0) {
        if($('#newCards2').css('display') == 'block'){
          $('#newCards2 #cvn-what').trigger('click');
          $('#newCards2 #cvn-what').trigger('click');
        }
        if($('#qcProfile2').css('display') == 'block'){
          $('#qcProfile2 #cvn-what').trigger('click');
          $('#qcProfile2 #cvn-what').trigger('click');
        }
      }
    });
  }
};
